import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'catalog-levels-of-education',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'catalog-levels-of-education-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                                        {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.catalog-levels-of-education-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "catalog-levels-of-education-index" */ '@/modules/configurations/catalogs/catalog-levels-of-education/views/Index.vue')
        }
    ]
}
